/** Date format helpers for rebate status cards (Intl options live here so card TSX stays i18n-clean). */

const MONTH_YEAR_UTC: Intl.DateTimeFormatOptions = {
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
};

export function formatRebateStatusMonthYearUtc(date: Date): string {
  return new Intl.DateTimeFormat('en-US', MONTH_YEAR_UTC).format(date);
}
